import * as Yup from 'yup';

import { optionalString, requiredString } from '@/validation/common/primitives';

const optionalNonNegativeNumber = Yup.number()
  .transform((value, originalValue) =>
    originalValue === '' || originalValue === null || Number.isNaN(value) ? undefined : value,
  )
  .min(0, { key: 'errors.form.minNumber', min: 0 })
  .optional();

export const createCatalogItemSchema = Yup.object({
  storeId: requiredString,
  itemNumber: requiredString,
  vendorName: optionalString,
  productDescription: requiredString,
  shelfLocation: optionalString,
  category: optionalString,
  retailPrice: optionalNonNegativeNumber,
  unitCost: optionalNonNegativeNumber,
});
